import {
  WSCard,
  WSDivider,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSList,
  WSPill,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { WorkLog } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { queriesWorkLogs } from "@query";
import { routeHelpersWorkLogPayerDetails } from "../paths";
import { getWorkLogPayerStatusCellProps } from "../utils/getWorkLogPayerStatusCellProps";

type Props = {
  workLog?: WorkLog;
  shimmer?: boolean;
};

export const WorkLogsInPayPeriod: React.FC<Props> = props => {
  const goToWorkLog = routeHelpersWorkLogPayerDetails.useGoTo();

  const payeeEngagementId = props.workLog?.payeeEngagementId;
  const payPeriodId = props.workLog?.payPeriodId;

  // Fetch this engagement's work logs for the current pay period directly via the
  // server-side `payPeriodId` filter — no more fetching by engagement and narrowing
  // to the pay period client-side.
  const queryWorkLogs = queriesWorkLogs.listWorkLogs.useQuery(
    {
      filter: {
        payeeEngagementId: { eq: payeeEngagementId! },
        payPeriodId: { eq: payPeriodId! }
      },
      page: { size: 50 }
    },
    { enabled: !!payeeEngagementId && !!payPeriodId }
  );

  if (props.shimmer || !payPeriodId) {
    return null;
  }

  const siblingWorkLogs = queryWorkLogs.data?.data ?? [];

  if (siblingWorkLogs.length === 0) {
    return null;
  }

  return (
    <WSElement>
      <WSSectionToolbar title="Work logs in this pay period" />
      <WSCard>
        <WSList gap="NONE">
          {siblingWorkLogs.map((sibling, index) => {
            const isCurrentWorkLog = sibling.id === props.workLog?.id;
            const { pill } = getWorkLogPayerStatusCellProps({
              workLog: sibling
            });

            return (
              <React.Fragment key={sibling.id ?? index}>
                {index > 0 && <WSDivider />}
                <WSFlexBox
                  justify="space-between"
                  alignItems="center"
                  py="M"
                  onClick={
                    isCurrentWorkLog || !sibling.id
                      ? undefined
                      : () => goToWorkLog({ workLogId: sibling.id! })
                  }
                >
                  <WSFlexBox.CenterY gap="S">
                    <WSText.ParagraphSm color="gray700">
                      #{sibling.workLogNumber}
                    </WSText.ParagraphSm>
                    {isCurrentWorkLog && (
                      <WSPill text="Viewing" theme="blue" icon="view" />
                    )}
                  </WSFlexBox.CenterY>

                  <WSFlexBox.CenterY gap="S">
                    {pill && <WSPill {...pill} />}
                    {!isCurrentWorkLog && (
                      <WSIcon name="chevron-right" color="gray400" size="XS" />
                    )}
                  </WSFlexBox.CenterY>
                </WSFlexBox>
              </React.Fragment>
            );
          })}
        </WSList>
      </WSCard>
    </WSElement>
  );
};
